import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import TablaEvidencias from './TablaEvidencia'
import TablaBitacora from './TablaBitacora';
import TablaRefaccion from './TablaRefaccion';
//import TablaHorometro from './TablaHorometro';
import TablaIncidencias from './Incidencias/TablaIncidencias';
//import TablaCombustible from './Combustible/TablaCombustible';
import Combustible from './Combustible';
import Horometro from './Horometro';
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={1}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    padding:0,
    fontSize:"12px",
    marginLeft:.6+'rem',
  },
}));

export default function RepoTab({regisMaquinaria,   }) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <Box  >
      <AppBar position="static" color="transparent"  >
        <Tabs 
          value={value} onChange={handleChange}  scrollButtons="auto"
          aria-label="simple tabs example" indicatorColor="secondary" //centered
          textColor="secondary"  variant="scrollable"            size="small"          
        >
          <Tab label="Bitacora" {...a11yProps(0)} size="small"  />
          <Tab label="Refacción" {...a11yProps(1)} size="small"  />
          <Tab label="Evidencia" {...a11yProps(2)} size="small"  />
          <Tab label="Incidencia" {...a11yProps(3)} size="small" />  
          <Tab label="Horómetro" {...a11yProps(4)} size="small"  />
          
          <Tab label="Combustible" {...a11yProps(5)} size="small" />  
        </Tabs>
      </AppBar>
      </Box>
      <TabPanel value={value} index={0} >
        <TablaBitacora regisMaquinaria={regisMaquinaria}   />
      </TabPanel>
      <TabPanel value={value} index={2} >
        <TablaEvidencias orden={regisMaquinaria}/>
      </TabPanel>
      <TabPanel value={value} index={1} >
        <TablaRefaccion regisMaquinaria={regisMaquinaria}/>
      </TabPanel>
      <TabPanel value={value} index={3} >
        <TablaIncidencias regisMaquinaria={regisMaquinaria}/>
      </TabPanel>
      <TabPanel value={value} index={4} >
        <Horometro regisMaquinaria={regisMaquinaria}/>
      </TabPanel>
      
      <TabPanel value={value} index={5} >
        <Combustible regisMaquinaria={regisMaquinaria}/>
       {/*  <TablaCombustible regisMaquinaria={regisMaquinaria}/> */}
      </TabPanel>
    </div>
  );
}